"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttemptToGetUnassignedComponent = exports.AttemptToRemoveUnassignedComponent = exports.AttemptToUpdateUnassignedComponent = exports.AttemptToAssignDuplicateComponent = exports.EntityError = exports.Entity = void 0;
class Entity {
    constructor(scene, updateQueue) {
        this.scene = scene;
        this.updateQueue = updateQueue;
        this.componentsStore = new Map();
        this.childrenStore = new Set();
        this.children = (() => {
            const self = this;
            const store = this.childrenStore;
            function create() {
                const child = self.scene.entities.create();
                store.add(child);
                return child;
            }
            return { create };
        })();
    }
    add(CC, initialValue = {}) {
        if (this.componentsStore.has(CC))
            throw new AttemptToAssignDuplicateComponent(this, CC);
        const component = new CC();
        Object.assign(component, initialValue);
        this.componentsStore.set(CC, component);
        this.updateQueue.queueForUpdate(this);
        return this;
    }
    update(CC, overwriteValue) {
        if (!this.componentsStore.has(CC))
            throw new AttemptToUpdateUnassignedComponent(this, CC);
        const component = this.componentsStore.get(CC);
        Object.assign(component, overwriteValue);
        return this;
    }
    build(builderFn) {
        return builderFn(this);
    }
    remove(CC) {
        if (!this.componentsStore.has(CC))
            throw new AttemptToRemoveUnassignedComponent(this, CC);
        this.componentsStore.delete(CC);
        this.updateQueue.queueForUpdate(this);
        return this;
    }
    has(CC) {
        return this.componentsStore.has(CC);
    }
    get(CC) {
        if (!this.componentsStore.has(CC))
            throw new AttemptToGetUnassignedComponent(this, CC);
        return this.componentsStore.get(CC);
    }
}
exports.Entity = Entity;
class EntityError extends Error {
    constructor(message) {
        super(`[EntityError]: ${message}`);
    }
}
exports.EntityError = EntityError;
class AttemptToAssignDuplicateComponent extends EntityError {
    constructor(entity, CC) {
        super(`Component "${CC.name}" cannot be assigned to entity, ` +
            `because the entity already has a component "${CC.name}".`);
        this.entity = entity;
        this.CC = CC;
    }
}
exports.AttemptToAssignDuplicateComponent = AttemptToAssignDuplicateComponent;
class AttemptToUpdateUnassignedComponent extends EntityError {
    constructor(entity, CC) {
        super(`Component "${CC.name}" cannot be updated for entity, ` +
            `because the entity has no component "${CC.name}".`);
        this.entity = entity;
        this.CC = CC;
    }
}
exports.AttemptToUpdateUnassignedComponent = AttemptToUpdateUnassignedComponent;
class AttemptToRemoveUnassignedComponent extends EntityError {
    constructor(entity, CC) {
        super(`Component "${CC.name}" cannot be removed from entity, ` +
            `because the entity has no component "${CC.name}".`);
        this.entity = entity;
        this.CC = CC;
    }
}
exports.AttemptToRemoveUnassignedComponent = AttemptToRemoveUnassignedComponent;
class AttemptToGetUnassignedComponent extends EntityError {
    constructor(entity, CC) {
        super(`Component "${CC.name}" cannot be obtained from entity, ` +
            `because the entity has no component "${CC.name}".`);
        this.entity = entity;
        this.CC = CC;
    }
}
exports.AttemptToGetUnassignedComponent = AttemptToGetUnassignedComponent;
